module.exports = {
  "defaultLanguage": "de-DE",
  "languages": [
    {
      "code": "en-US",
      "name": "English",
      "icon": null
    },
    {
      "code": "de-DE",
      "name": "Deutsch",
      "icon": null
    }
  ]
}